<template>
  <el-row>
    <el-row class="bottom20">
      <el-table :data="page.records">
        <el-table-column prop="jobtaskid">
          <template slot="header" slot-scope="scope">
            操作步骤
          </template>
          <template slot-scope="scope">
            <dictionary-text :dictionary="jobTaskDictionary" :value="scope.row.jobtaskid"></dictionary-text>
          </template>
        </el-table-column>
        <el-table-column prop="assettype">
          <template slot="header" slot-scope="scope">
            资产类型
          </template>
          <template slot-scope="scope">
            <dictionary-text :factory-name="'domain'" :params="'ASSETTYPE'" :value="scope.row.assettype"></dictionary-text>
          </template>
        </el-table-column>
        <el-table-column prop="assetattrid">
          <template slot="header" slot-scope="scope">
            点位类型
          </template>
          <template slot-scope="scope">
            <dictionary-text :dictionary="assetAttrDictionary" :value="scope.row.assetattrid"></dictionary-text>
          </template>
        </el-table-column>
        <el-table-column prop="locationCode">
          <template slot="header" slot-scope="scope">
            操作
          </template>
          <template slot-scope="scope">
            <div>
              <el-button type="danger" plain size="minimum" @click="toDelete(scope.row)" :disabled="!deletable">删除</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row type="flex" class="row-bg" justify="end">
      <el-pagination
              @current-change="handleCurrentChange"
              @size-change="handleSizeChange"
              :current-page="pageSearch.current"
              :page-sizes="[10, 25, 50, 100]"
              :page-size="pageSearch.size"
              layout="total, sizes, prev, pager, next, jumper"
              :total="page.total">
      </el-pagination>
    </el-row>
  </el-row>
</template>

<script>
  import { debounce } from "@/util/common"
  import { Dictionary } from '@/util/common/dictionary'
  import DomainSelect from '@/components/domainaln'
  import DictionarySelect from '@/components/common/DictionarySelect'
  import DictionaryText from '@/components/common/DictionaryText'
  import DeptSelect from '@/components/dept'
  import {selected, visited, pageFactory} from  '@/views/workorder/mixins/table'
  import {WorkOrderServer, AssetServer} from  '@/api'
  export default {
    name: "JobPlanSpecList",
    mixins: [selected, visited, pageFactory({debounce: 500})],
    components: {
      DictionarySelect, DictionaryText,
    },
    props: {
      jobPlanId: {},
      type: {},
      addable: {
        type: Boolean,
        default: false,
      },
      updatable: {
        type: Boolean,
        default: false,
      },
      deletable: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        jobTaskDictionary: new Dictionary(),
        assetAttrDictionary: new Dictionary(),
        pageSearch: {
          search: {
            eq_jobplanid: -1,
            eq_type: ''
          }
        },
      };
    },
    watch: {
      jobPlanId: {
        immediate: true,
        handler() {
          this._initJobTaskDictionary(this.jobPlanId);
          this.pageSearch.search.eq_jobplanid = this.jobPlanId;
        }
      },
      type: {
        immediate: true,
        handler() {
          this.pageSearch.search.eq_type = this.type;
        }
      }
    },
    methods: {
      _initJobTaskDictionary(jobPlanId) {
        WorkOrderServer.jobTask.list({jobplanid: jobPlanId}).then(res => {
          if (res.data.code === 200) {
            this.jobTaskDictionary = new Dictionary({items: res.data.result, valueKey: 'jobtaskid', textKey: 'description'});
          }
        }, error => {
          this.$message.error(error);
        });
      },
      _initAssetAttrDictionary() {
        AssetServer.assetAttribute.all({}).then(res => {
          console.log(`asset attribute all`, res)
          if (res.data.code === 200) {
            this.assetAttrDictionary = new Dictionary({items: res.data.data, valueKey: 'assetattrid', textKey: 'description'});
          }
        }, error => {
          window.console.error(error);
          this.$message.error(error.message);
        });
      },
      queryByPage(pageSearch) {
        WorkOrderServer.jobPlanSpec.page(pageSearch).then((res) => {
          if (res.data.code === 200) {
            this.page = {
              total: res.data.result.total,
              records: res.data.result.records
            }
          }
        });
      },
      toDelete(data) {
        this.$confirm('确定删除吗？', '删除提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          WorkOrderServer.jobPlanSpec.delete(data['jobplanspecid'], {loading: true}).then((res) => {
            if (res.data.code === 200) {
              this.$message.success('删除成功！');
              this.executeQueryByPage();
            } else {
              this.$message.error('删除失败！');
            }
          });
        });
      },
      refresh() {
        // 初始化资产点位类型
        this._initAssetAttrDictionary();

        // 初始化操作步骤
        this._initJobTaskDictionary(this.jobPlanId);

        // 重新分页查询
        this.reQueryByPage();
      }
    },
    created() {
      this._initAssetAttrDictionary();
    }
  }
</script>

<style scoped>

</style>